<div class="merging-details-section">
  <h3 class="merging-details-section__title">
    {{ 'MergeTripTab.MergingDetails' | translate | uppercase }}
  </h3>
  <div class="merging-details-section__content">
    <div class="merging-details-section__start">
      <div class="merging-details-section__start--text">
        {{ 'MergeTripTab.Start' | translate }}
      </div>
      <div class="merging-details-section__start--icons">
        <span class="dv-icons">start</span>
        <div class="merging-details-section__start--connection"></div>
      </div>
      <div class="merging-details-section__start--info">
        <br />
        {{ startInfo()?.StartLocation }} <br />
        <span class="merging-details-section__start--info-1">{{
          $safeNavigationMigration(startInfo()?.StartTime)
            | date: 'dd.MM.yyyy H:mm'
        }}</span>
      </div>
    </div>
    <div class="merging-details-section__gap">
      <div class="merging-details-section__gap--chip">
        {{ (distance() === 0 ? '' : distance()) + 'km' }}
      </div>
      @if (isTripMerged()) {
        <div class="merging-details-section__gap--line"></div>
        <div class="merging-details-section__gap--icon">
          <span class="dv-icons">table_merge_cells</span>
        </div>
        <div class="merging-details-section__gap--text">
          {{ 'MergeTripTab.Merged' | translate }}
        </div>
      }
    </div>

    <div class="merging-details-section__end">
      <div class="merging-details-section__end--text">
        {{ 'MergeTripTab.End' | translate }}
      </div>
      <div class="merging-details-section__end--icons">
        <span class="dv-icons">end</span>
        <div class="merging-details-section__end--connection"></div>
      </div>
      <div class="merging-details-section__end--info">
        <br />
        {{ endInfo()?.EndLocation }} <br />
        <span class="merging-details-section__end--info-1">{{
          $safeNavigationMigration(endInfo()?.EndTime) | date: 'dd.MM.yyyy H:mm'
        }}</span>
      </div>
    </div>
  </div>
</div>
